module.exports = __webpack_public_path__ + "static/img/anota.b03945a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/full/projects/anota.png
// module id = Ytv/
// module chunks = 0